// --- React Query Refetch Helper ---
// Simple explanation: Calculate delay so refetch happens a few times an hour.
// Technical: Next refetch at minute 3, 30, or 45 (whichever comes next).

export function refetchIntervalFn() {
  const now = new Date();
  const min = now.getMinutes();
  const sec = now.getSeconds();
  const refreshMinutes = [3, 30, 45];
  const next = refreshMinutes.find((m) => m > min) ?? refreshMinutes[0] + 60;
  let nextMin = next;
  if (next < min) nextMin += 60;
  const delay = ((nextMin - min) * 60 - sec) * 1000;
  return delay > 0 ? delay : 60 * 1000; // fallback 1 min
}
